import axiosInstance from "../../utils/config/config";

export const getAllPosts = () => async (dispatch) => {
  try {
    dispatch({
      type: "getAllPostsRequest",
    });
    const { data } = await axiosInstance.get(`/post/getAllPosts`);
    dispatch({
      type: "getAllPostsSuccess",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "getAllPostsFailure",
      payload: true,
    });
  }
};
